import * as React from "react";
const SvgTerrain3D = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "#0B4566", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22 14l-3.75 5 2.85 3.8-1.6 1.2c-1.69-2.25-4.5-6-4.5-6l-6 8h22l-9-12z" }));
export default SvgTerrain3D;
